<section *ngIf="loading">
  <h2>Loading...</h2>
  <mat-progress-bar mode="indeterminate" color="primary" aria-label="Loading...">
  </mat-progress-bar>
</section>

<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start" *ngIf="!loading">
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <span *ngIf="waterSystemId > 0">
        <mat-icon>edit</mat-icon> Edit Housing Unit Water System OHA Id: {{waterSystemId}}
      </span>
      <span *ngIf="waterSystemId == 0">
        <mat-icon>edit</mat-icon> Add Housing Unit Water System
      </span>
    </h2>
  </div>
  <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="end">
    <button mat-button mat-dialog-close="Cancel" mat-raised-button color="basic" aria-label="Cancel" title="Cancel" [disabled]='loading'>
      Close
    </button>
  </div>
</div>

<mat-dialog-content>
  <div *ngIf="!loading">
    <form [formGroup]="waterSystemForm">
      <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <mat-card fxFlex="100">

            <div fxLayout="row wrap" fxLayoutGap="8px grid" class="matero-row">
              <div fxFlex.lt-sm="50">
                <mat-form-field>
                  <input matInput placeholder="Name" formControlName="name">
                </mat-form-field>
              </div>
              <div fxFlex.lt-sm="50">
                Active: <br />
                <mat-checkbox formControlName="active"></mat-checkbox>
              </div>
            </div>

            <div fxLayout="row wrap" fxLayoutGap="8px grid">
              <div fxFlex="100" fxFlex.lt-sm="100">
                <mat-form-field appearance="standard">
                  <mat-label>Comments</mat-label>

                  <textarea matInput placeholder="Comments" formControlName="comments"></textarea>
                </mat-form-field>
              </div>
            </div>

          </mat-card>
        </div>
      </div>
      <div fxLayout="row wrap" class="matero-row" *ngIf="!loading">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
          <button type="submit" id="submitButtonSearch" mat-raised-button color="primary" title="Update Housing Unit Water System" (click)="save()" [disabled]="authService.isReadOnly()">Update
            Housing Water System</button>
        </div>
      </div>
    </form>
  </div>
</mat-dialog-content>